import {lazyWithRetry} from '../lazyWithRetry/lazyWithRetry';

export const LazyTagManagement = lazyWithRetry(() => import('./TagManagement'));
